import { BLANK } from 'shared_critical/constants/string';
import { abbreviateCurrency, formatLoanTypes } from "shared_critical/format_helper";

MOVE.MORTGAGE.RATES_PAGE = (function (MORTGAGE) {
  var includeZip = true,
    $locationBoxField = $('#locationBox'),
    $providerDisclaimerContainer = $('.mrtg-rates-provider-disclaimer .disclaimer-container'),
    $rateCardContainer = $('.mrtg-rate-card-container'),
    $propertyPrice = $('#home-price'),
    $downPayment = $('.down-pay-dollar'),
    $templatePath = 'templates/mortgage/',
    $pagination = $('#pagination'),
    props;

  var init = function () {
    var loan_purpose = MOVE.MORTGAGE.getQueryValue('loan_purpose') || 'purchase';
    var loan_type = MOVE_DATA.loan_type;
    var provider = MOVE_DATA.provider;
    props = {
      search: {
        provider: provider,
        purpose: loan_purpose,
        location: null,
        zip: null,
        price: 400000,
        down_payment: loan_purpose === 'purchase' ? 80000 : 320000,
        down_payment_percent: loan_purpose === 'purchase' ? 20 : 80,
        loan_types: loan_type === undefined ? ['30YrFixed'] : [loan_type],
        credit_score: 'excellent',
        pts: 'all',
        geo_valid: false,
        mprid: null,
        mlid: null
      },
      sort: 'relevance',
      pagination: {
        page: 1,
        items: [],
        perPage: MOVE.Helper.isPhone() ? 6 : 10,
        total: 0,
        totalPages: 0
      },
      rates: [],
      ratesToDisplay: [],
      is_mobile_app: MOVE.MORTGAGE.getQueryValue('from') === 'mobile'
    };

    MOVE.MORTGAGE.locationControlAutoCompleteSetup(
      $locationBoxField,
      MOVE.MORTGAGE.RATES.SEARCH_VIEW.actions.locationChanged,
      includeZip
    );

    MOVE.MORTGAGE.RATES.SEARCH_VIEW.init(props);
    MOVE.MORTGAGE.RATES.SORT_VIEW.init(props);
    MOVE.MORTGAGE.RATES.PAGINATION_VIEW.init(props);

    toggleMobileAppView();
    monitorDom();
    MOVE.MORTGAGE.trackClick();
  };

  var monitorDom = function () {
    initHashLocation();
    initDOM();
    initilizeRateTable();
    initNewsTicker();
  };

  // Handle legacy params supplied as hash location
  // Assign valid options to props prior to analysis call
  var initHashLocation = function () {
    var hash = MOVE.MORTGAGE.getUrlVars();
    if (hash !== null) {
      if (hash.loan_purpose && hash.loan_purpose == 'refinance') {
        props.search.purpose = 'refinance';
      }
      if (hash.location) {
        props.search.location = decodeURIComponent(hash.location);
        props.search.zip = null;
      }
      if (hash.zip) {
        props.search.zip = hash.zip;
      }
      if (hash.property_price) {
        var price = parseInt(hash.property_price, 10);
        if (!isNaN(price)) {
          props.search.price = price;
          props.search.down_payment = price * 0.2;
        }
      }
      if (hash.mprid) {
        props.search.mprid = hash.mprid;
      }
      if (hash.mlid) {
        props.search.mlid = hash.mlid;
      }
      if (hash.iid == 'ldpmrtgtab30yf') {
        props.search.loan_types = ['30YrFixed'];
      }
      if (hash.iid == 'ldpmrtgtab15yf') {
        props.search.loan_types = ['15YrFixed'];
      }
      if (hash.iid == 'ldpmrtgtab51arm') {
        props.search.loan_types = ['5Arm'];
      }
      props.iid = hash.iid || hash.reference;
    }
    MOVE.MORTGAGE.RATES.SEARCH_VIEW.render();
  };

  var initDOM = function () {
    // Respond to event from view classes to refresh rates to display
    $('body').on('rates.displayCards', function() {
      props.ratesToDisplay = ratesToDisplay();
      displayCards();
    });
    return MOVE.Helper.isPhone() ? initMobileDOM() : initDesktopDOM();
  };

  var initNewsTicker = function () {
    MOVE.MultilineEllipsis.init($('.js-multiline-ellipsis'));
  };

  var initilizeRateTable = function () {
    displayLoadingSpinner();
    var location = MOVE_DATA.state_page ? MOVE_DATA.state_search_location :
      MOVE_DATA.city_page ? MOVE_DATA.city_search_location : BLANK;
    var analysisParams = {
      mprid: props.search.mprid,
      mlid: props.search.mlid,
      property_price: props.search.price,
      location: location
    };
    MOVE.MORTGAGE.RATES.REQUESTS.getAnalysis(analysisParams, function (data) {
      var search = props.search;
      search.price = data.analysis.target_price;
      search.location = data.analysis.location.location
      search.zip = data.analysis.location.zip;
      search.city = data.analysis.location.city;
      search.state = _.escape(data.analysis.location.state);
      MOVE.MORTGAGE.RATES.REQUESTS.getRateTable({
        provider: search.provider,
        zip: search.zip,
        property_price: search.price,
        loan_purpose: search.purpose,
        loan_types: search.loan_types,
        credit_score: search.credit_score,
        pts: search.pts,
        ltv: search.ltv,
        success: updateRatesFromRequest,
        error: noRatesFound
      });
      initForm();
      updateTrendsHeading(search.state);
      MOVE.MORTGAGE.RATE_TRENDS.getRatesTrendsData(data.analysis.location.state, props.search.purpose === 'refinance');
      searchDescription(search);
    });
  };

  var searchDescription = function (search)
  {
    var $searchCriteria = $('.search-criteria-desc');
    if ($searchCriteria.length > 0)
    {
      $searchCriteria.html('');
      var template = $templatePath + 'rate_table_search_description';
      $searchCriteria.append(JST[template]({
        location: search.city + ", " + search.state,
        price: abbreviateCurrency(search.price),
        loan_amount: search.purpose === 'purchase' ? abbreviateCurrency(search.price-search.down_payment) : abbreviateCurrency(search.down_payment),
        purpose: search.purpose === 'purchase' ? 'purchase' : 'refi',
        down_payment: Math.round(search.down_payment_percent),
        loan_types: displayLoanType(search.loan_types),
        points: displayPoints(search.pts),
        credit: search.credit_score === 'excellent' ? '740+' : search.credit_score
      }));
    }
  };

  var displayPoints = function(points){
    var displayValue = "";
    switch (points) {
      case 'zero':
        displayValue = '0 points';
        break;
      case 'zero_to_one':
        displayValue = 'up to 1 point';
        break;
      case 'one_to_two':
        displayValue = 'up to 2 points';
        break;
      default:
        displayValue = 'all points';
    }
    return displayValue;
  };

  var displayLoanType = function(types) {
    var displayValue = [];
    var allLoanTypes = formatLoanTypes();
    $.each(types, function (i, type) {
      $.each(allLoanTypes, function(index, value){
        if (value[type] !== undefined){
          displayValue.push(value[type]);
        }
      })
    })
    return displayValue.join(', ');
  };

  var initForm = function () {
    if (props.search.purpose === "refinance") {
      $downPayment.parents('li').find('label').html('Loan Amount');
      $propertyPrice.parents('li').find('label').html('Home Value');
    }
    $locationBoxField.val(props.search.location);
    $propertyPrice.val(MOVE.MORTGAGE.addDollarCommas(props.search.price));
  };

  var updateTrendsHeading = function (state) {
    var heading =
      labelForStateCode(state) + ' Mortgage Rate Trends';
    $('.mrtg-rate-trends').find('h2 > span').html(heading);
  };

  var initMobileDOM = function () {
    MOVE.Common.readMore('.state-rate-header', 40);
    MOVE.MORTGAGE.RATES.SORT_VIEW.bind();
    bindSearchView();
  };

  var initDesktopDOM = function () {
    MOVE.Common.readMore('.state-rate-header', 80);
    MOVE.MORTGAGE.RATES.SORT_VIEW.bind();
    bindSearchView();
  };

  var bindSearchView = function() {
    MOVE.MORTGAGE.RATES.SEARCH_VIEW.bind({
      searchRates: searchRates,
      searchTrends: MOVE.MORTGAGE.RATE_TRENDS.getRatesTrendsData,
      updateTrendsHeading: updateTrendsHeading
    });
  };

  var labelForStateCode = function (state_code) {
    if (!MOVE_DATA.state) {
      return '';
    }
    return _.pick(MOVE_DATA.state, state_code)[state_code];
  };

  var trackPageView = function (data) {
    var state = MOVE_DATA.state_page === undefined ? '' : '_state',
        loan_type = MOVE_DATA.loan_type === undefined ? '' : '_loan_type',
        city =  MOVE_DATA.city_page === undefined ? '' : '_city',
        page_name = 'finance:' + 'rate_table_' + data.search.purpose + state + loan_type + city;
    MOVE_DATA.adobeDTM = {
      appVersion: '8.0.0.1',
      identityStatus: MOVE_DATA.memberId === null ? 'not-registered' : 'registered',
      identityID: MOVE_DATA.memberId,
      userTesting: 'renovate:dialUp:testGroup',
      siteSection: 'finance',
      pageType: 'rate-table',
      hubName: 'hub',
      rdcTrackingEnabled: 'y',
      iid: data.iid,
      state: data.search.state,
      city: data.search.city,
      zip: data.search.zip,
      homePrice: data.search.price,
      pageID: 'rate_table_' + data.search.purpose + state + loan_type + city,
      searchPage: data.pagination.page,
      searchResultCount: data.pagination.total
    };
    window.RdcTracking.trackPage(page_name, MOVE_DATA.adobeDTM);
  };

  var searchRates = function () {
    displayLoadingSpinner();
    $pagination.hide();
    var search = props.search;
    MOVE.MORTGAGE.RATES.REQUESTS.getRateTable({
      provider: search.provider,
      zip: search.zip,
      property_price: MOVE.MORTGAGE.removeDollarCommas($('#home-price')),
      loan_purpose: search.purpose,
      loan_types: search.loan_types,
      credit_score: search.credit_score,
      pts: search.pts,
      ltv: search.ltv,
      success: function (data) {
        updateRatesFromRequest(data);
        displaySearchResultsForMobile();
      },
      error: noRatesFound
    });
    searchDescription(search);
  };

  var updateRatesFromRequest = function (data) {
    if (data.full_rates) {
      props.rates = data.full_rates.mortgage_rates;
      props.disclosures = data.full_rates.disclosures;
      props.primary_rates = data.full_rates.is_primary_rates;
      $(props.rates).each(function (i, o) {
        o['id'] = i,
        o['purpose'] = props.search.purpose.charAt(0).toUpperCase() + props.search.purpose.slice(1).toLowerCase();
      });
    } else {
      props.rates = [];
      props.disclosures = [];
      props.primary_rates = [];
    }

    props.pagination.page = 1; // Reset to first page
    props.ratesToDisplay = ratesToDisplay();
    props.selectedRate = [];
    displayAdvertisingDisclosure();
    displayCards();
  };

  var noRatesFound = function () {
    updateRatesFromRequest({full_rates: null});
  };

  var ratesToDisplay = function () {
    var rates = _.clone(props.rates);

    // Sort
    rates = MOVE.MORTGAGE.RATES.SORT.byType(rates, props.sort);

    // Paginate
    props.pagination =
      MOVE.MORTGAGE.RATES.PAGINATION.getPage(rates, props.pagination.page, props.pagination.perPage);

    return props.pagination.items;
  };

  var goPageTop = function () {
    return $rateCardContainer.find('.mrtg-rate-card').length === 0
  };

  var displayCards = function () {
    var goTop = goPageTop();
    $rateCardContainer.empty();
    if (props.ratesToDisplay.length === 0) {
      $('.advertising-disclosure').addClass('hide');
      $('.mrtg-rates-provider-disclaimer').addClass('hide');
      MOVE.MORTGAGE.RATES.MESSAGE_VIEW.init(props);
    } else {
      $('.advertising-disclosure').removeClass('hide');
      $('.mrtg-rates-provider-disclaimer').removeClass('hide');
      displayProviderDisclaimer();
      openDisclosureFromDesktopLink();
      openDisclosureFromLink();
      _.each(props.ratesToDisplay, function (rate) {
        var template = $templatePath + cardTemplate();
        $rateCardContainer.append(JST[template]({
          rate: rate,
          rateAsJSON: JSON.stringify(rate).replace(/"/g, "'"),
          loan_type: rate.loan_type_display_name ? rate.loan_type_display_name.replace('Yr', 'Year') : "",
          featured: !props.primary_rates && rate.is_sponsored ? "featured-rate-row" : ""
        }));
      });
    }
    MOVE.MORTGAGE.RATES.PAGINATION_VIEW.render();
    scrollToTopCard(goTop);
    trackPageView(props);
    MOVE.MORTGAGE.trackClick($rateCardContainer);
  };

  var cardTemplate = function () {
    return (MOVE.Helper.isPhone()) ?
      'rate_table_card_mobile' :
      'rate_table_card';
  };

  var displaySearchResultsForMobile = function () {
    if (!MOVE.Helper.isMobileDevice()) return;
    $('.js-mrtg-rates-search-mobile').slideUp('fast', function () {
      $('.js-mrtg-rate-table-mobile').slideDown('fast', function () {
        displayAdvertisingDisclosure();
        scrollToTopCard();
      });
    });
  };

  var displayAdvertisingDisclosure = function () {
    $('.js-advertising-disclosure').show();
  };

  var scrollToTopCard = function (goTop) {
    var position = 0;
    if (!goTop) {
      if (MOVE.Helper.isPhone()) {
        position = $('.js-mrtg-rate-table-mobile').offset().top;
      } else {
        position = getRateTableOffset();
      }
    }
    $('html, body').animate({scrollTop: position}, 600);
  };

  var getRateTableOffset = function(){
    var statePage = $('.state-mrtg-rates-header').length > 0,
        cityPage = $('.city-mrtg-rates-header').length > 0,
        loanTypePage = $('.product-mrtg-rates-header').length > 0,
        offset = 0;

    if (statePage) {
      offset = $('.js-state-header').offset().top;
    }else if (loanTypePage) {
      offset = $('.js-product-header').offset().top;
    }else if (cityPage) {
      offset = $('.js-city-header').offset().top;
    }
    else {
      offset = $('.js-mrtg-rates-header').offset().top;
    }
    return offset;
  }

  var displayLoadingSpinner = function () {
    var content =
      '<div id="rates-loading-spinner" class="loading-graphic"></div>';
    $rateCardContainer.html(content);
  };

  var displayProviderDisclaimer = function () {
    $providerDisclaimerContainer.empty();
    var template = $templatePath + 'rate_table_provider_disclaimer';
    var className = MOVE.Helper.isPhone()? 'small': '';

    $providerDisclaimerContainer.append(JST[template]({
      provider: props.disclosures,
      className
    }));

    $('.mrtg-rates-provider-disclaimer').removeClass('hide');
  };

  var toggleMobileAppView = function () {
    if (props.is_mobile_app) {
      hideNonRateTableStuff();
    } else {
      showNonRateTableStuff();
    }
  };

  var hideNonRateTableStuff = function () {
    $('#header-navbar').addClass('hide');
    $('#footer').addClass('hide');
    $('.js-rate-table-ad ').addClass('hide');
  };

  var showNonRateTableStuff = function () {
    $('#header-navbar').removeClass('hide');
    $('#footer').removeClass('hide');
    $('#bottomSection').removeClass('hide');
    $('.js-rate-table-ad ').removeClass('hide');
  };

  // Scroll from Ad Disclosure desktop link
  var openDisclosureFromDesktopLink = function () {
    $('.advertising-disclosure.desktop').on('click', function () {
      var disclosurePos = $('.mrtg-rates-provider-disclaimer').offset().top;
      $('html, body').animate({scrollTop: disclosurePos - 280}, 600);
    })
  };

  // Expand disclosure details when user clicks on Ad Disclosure link
  var openDisclosureFromLink = function () {
    $('.advertising-disclosure').on('click', function () {
      if (!$('#collapse-rate-disclaimer').hasClass('collapse in')) {
        $('#collapse-rate-disclaimer').collapse('show');
        $('.toggle-rate-disclaimer .arrow-toggle').removeClass('ra-angle-down').addClass('ra-angle-up');
      }
    })
  };

  MORTGAGE.RATES_PAGE = {
    init: init
  };
  return MORTGAGE.RATES_PAGE;

})(MOVE.MORTGAGE || {});



// WEBPACK FOOTER //
// ./mortgage/rates/rate_page.js